import io from 'socket.io-client';
import baseUrl from '../../Base_Url/baseUrl';

const socket = io(baseUrl, {
  transports: ['websocket'],
  autoConnect: false,
  reconnection: true,
  reconnectionAttempts: 5,
  reconnectionDelay: 3000,
});


export default socket;
